export function FormatCurrency(value) {
  if (value == null || value === "") return "R$ 0,00";

  const num = Number(value);

  if (isNaN(num)) return "R$ 0,00";

  return num.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function BrlFormatCurrency(number) {
  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return formatter.format(number);
}

export function FormatPoints(number) {
  return Math.round(parseFloat(number)).toLocaleString("pt-BR");
}

export function FormatTotalCurrency(number) {
  if (number) {
    let strValue = "";
    const value = number;
    strValue = value.toString();
    const numberAux = parseFloat(strValue);
    const num = numberAux.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
    return num;
  } else return 0;
}

export function GetPriceRealAndPoints(item) {
  const money_de = item?.BRL?.price ? FormatCurrency(item?.BRL?.price) : false;
  const money = FormatCurrency(item?.BRL?.offer);
  const points_de = item?.points?.price || 0;
  const points = item?.points?.offer || 0;
  return {
    money_de: money_de,
    points_de: points_de,
    money: money,
    points: points,
  };
}

export function numberWithCommas(x) {
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(x);
}

/**
 * Arredonda um valor monetário para 2 casas decimais usando arredondamento para cima (ceiling).
 * Garante que qualquer valor com mais de 2 decimais seja arredondado para o próximo centavo.
 *
 * Exemplos:
 * - roundCurrency(779.437) => "779.44"
 * - roundCurrency(779.441) => "779.45"
 * - roundCurrency(2.204) => "2.21"
 * - roundCurrency(2.200) => "2.20"
 *
 * @param {number} value - O valor a ser arredondado
 * @returns {string} - O valor arredondado como string com 2 casas decimais
 */
export function roundCurrency(value) {
  if (value == null || value === "" || isNaN(Number(value))) {
    return "0.00";
  }

  // Usa Math.ceil para arredondamento sempre para cima
  // IMPORTANTE: Elimina erros de ponto flutuante verificando se o valor multiplicado
  // está muito próximo de um inteiro. Se estiver (diferença < 0.0001), usa o inteiro.
  // Isso evita que 2.22 * 100 = 222.000...003 seja arredondado para 223 em vez de 222
  const numValue = Number(value);
  const multiplied = numValue * 100;

  // Se estiver muito próximo de um inteiro (diferença < 0.0001), usa o inteiro
  // Caso contrário, aplica Math.ceil normalmente
  const isNearInteger = Math.abs(multiplied - Math.round(multiplied)) < 0.0001;
  const ceiled = isNearInteger ? Math.round(multiplied) : Math.ceil(multiplied);

  const divided = ceiled / 100;
  const result = divided.toFixed(2);

  // Retorna com exatamente 2 casas decimais
  return result;
}
